var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#7DCFED}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1119532 6870003l13760936 0c616087,0 1119532,506398 1119532,1125190l0 0c0,618792 -503445,1124812 -1119532,1124812l-13760936 0c-616087,0 -1119532,-506020 -1119532,-1124812l0 0c0,-618792 503445,-1125190 1119532,-1125190zm0 -5760003l13760936 0c616087,0 1119532,506410 1119532,1125201l0 0c0,618756 -503445,1124800 -1119532,1124800l-13760936 0c-616087,0 -1119532,-506044 -1119532,-1124800l0 0c0,-618792 503445,-1125201 1119532,-1125201zm378 11520006l6560708 0c616087,0 1119910,506422 1119910,1125201l0 0c0,618768 -503823,1124800 -1119910,1124800l-6560708 0c-616087,0 -1119910,-506032 -1119910,-1124800l0 0c0,-618780 503823,-1125201 1119910,-1125201z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.4546ec85d32af89728521e1df3d49d07.svg";
export { ForwardRef as ReactComponent };